"use strict";
angular.module("planCommandMonitorCustomFunctionManageModule", [])
    .controller('planCommandMonitorCustomFunctionManageCtrl', ['$scope', 'planCommandMonitorService', 'trsHttpService', '$filter','modalDialog',
        function($scope, planCommandMonitorService, trsHttpService, $filter,modalDialog) {
            initStatus();
            initData();
            /*** [initData description:初始化数据]*/
            function initData() {
                requestData();
            }
            /**[initStatus description:初始化状态]*/
            function initStatus() {
                $scope.page = {
                    CURRPAGE: 1,
                    PAGESIZE: 20,
                    ITEMCOUNT: '',
                    PAGECOUNT: '',
                    copyCurrPage: 1,
                };
            }
            /**
             * [share description] 打开分享弹窗
             * @param  {[type]} uurl [分享链接地址]
             * @param  {[type]} id   [场景ID]             
             */
            $scope.shareCus = function(id) {
                planCommandMonitorService.share(id, '8', "复制链接和密码");
            };
            /** [scan description:用于打开查看链接]*/
            $scope.scan = function(item) {
                window.open(item.url);
            };
            /** [timeStamp:将日期字符串转化为标准格式]*/
            $scope.timeStamp = function(info) {
                return $filter("date")(info.updtTime, "yyyy-MM-dd HH:mm:ss").toString();
            };
            /*** [requestData description:获取列表数据]*/
            function requestData() {
                $scope.params = {
                    "serviceid": 'mlf_bigdatascreen',
                    "methodname": 'queryDataFromBigScreen',
                    "modalname": 'customFuncMgr',
                    "method": 'search',
                    "page_no": $scope.page.CURRPAGE - 1,
                    "page_size": $scope.page.PAGESIZE,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'post').then(function(data) {
                    $scope.listInfo = data.mapResult.content.content;
                    $scope.page.ITEMCOUNT = data.mapResult.content.totalElements;
                    $scope.page.PAGECOUNT = data.mapResult.content.totalPages;
                });
            }
            $scope.$on('customFunc',function(){
                requestData();
            });
            /*** [deleteItem description:删除操作]*/
            $scope.deleteItem = function(group) {
                modalDialog.confirmModal('提示信息', '确定删除?',function() {
                    var delParams = {
                        "serviceid": 'mlf_bigdatascreen',
                        "methodname": 'queryDataFromBigScreen',
                        "modalname": 'customFuncMgr',
                        "method": 'delete',
                        "id": group.id
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), delParams, 'post').then(function() {
                        requestData();
                    });
                });
            };
            /**[selectPageNum description] 选择每页显示的数据数量*/
            $scope.selectPageNum = function() {
                $scope.page.copyCurrPage = 1;
                requestData();
            };
            /**[pageChanged description:跳转页面]*/
            $scope.pageChanged = function() {
                $scope.page.copyCurrPage = $scope.page.CURRPAGE;
                $scope.params.page_no = $scope.page.copyCurrPage;
                requestData();
            };
            /**[jumpToPage description:跳转到指定页面]*/
            $scope.jumpToPage = function() {
                if (!$scope.page.copyCurrPage) return;
                if ($scope.page.copyCurrPage > $scope.page.PAGECOUNT) {
                    $scope.page.copyCurrPage = $scope.page.PAGECOUNT;
                }
                $scope.page.CURRPAGE = $scope.page.copyCurrPage;
                requestData();
            };
            $scope.newAddCustomFuncMana=function(value){
                planCommandMonitorService.newAddCustomFuncMana(value);
            }
        }
    ]);